var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _line, _line2, _g, _g2, _rect2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIotBotnetDetection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "botnetGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a2d4d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2d4d6f",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#botnetGrad)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 25,
    fill: "none",
    stroke: "#ff6b6b",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 20,
    fill: "none",
    stroke: "#ff6b6b",
    strokeWidth: 1,
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 100,
    r: 25,
    fill: "none",
    stroke: "#ff6b6b",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 100,
    r: 20,
    fill: "none",
    stroke: "#ff6b6b",
    strokeWidth: 1,
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 25,
    fill: "none",
    stroke: "#ff6b6b",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 20,
    fill: "none",
    stroke: "#ff6b6b",
    strokeWidth: 1,
    opacity: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 80,
    x2: 200,
    y2: 200,
    stroke: "#ff6b6b",
    strokeWidth: 2,
    strokeDasharray: "5,5",
    opacity: 0.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 100,
    x2: 200,
    y2: 200,
    stroke: "#ff6b6b",
    strokeWidth: 2,
    strokeDasharray: "5,5",
    opacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 80)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 12,
    fill: "#00ff88",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -4 0 L -1 3 L 4 -2",
    stroke: "white",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 12,
    fill: "#00ff88",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -4 0 L -1 3 L 4 -2",
    stroke: "white",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 240,
    width: 80,
    height: 40,
    rx: 5,
    fill: "#00ff88",
    opacity: 0.15,
    stroke: "#00ff88",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 265,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#00ff88",
    fontWeight: "bold"
  }, "DETECTED")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotBotnetDetection);
export default __webpack_public_path__ + "static/media/iot_botnet_detection.37f100ed55626d73b014b7aa2ec1a1e8.svg";
export { ForwardRef as ReactComponent };